import { render, staticRenderFns } from "./RegisterCodes.vue?vue&type=template&id=00310de9"
import script from "./RegisterCodes.vue?vue&type=script&lang=js"
export * from "./RegisterCodes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports